import PackageAttributeInfoModal from './PackageAttributeInfoModal'

export * from './PackageAttributeInfoModal'

export default PackageAttributeInfoModal
